import axios from 'axios'
const qs = require('qs')

const state = {}

const actions = {
  fetchSingleTransaction ({ rootGetters }, id) {
    return axios
      .get(rootGetters['api/transactionsSingle'](id))
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  createTransaction ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/transactionsCreate'], data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  updateTransaction ({ rootGetters }, { id, data }) {
    return axios
      .put(rootGetters['api/transactionsUpdate'](id), data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  cancelTransaction ({ rootGetters }, id) {
    return axios
      .patch(rootGetters['api/transactionsCancel'](id))
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  waitTransaction ({ rootGetters }, { id, data }) {
    return axios
      .patch(rootGetters['api/transactionsWait'](id), data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  canAcceptCollectTransaction ({ rootGetters }, meta) {
    const params = qs.stringify(meta, { arrayFormat: 'repeat', addQueryPrefix: true })
    return axios.get(`${rootGetters['api/canAcceptCollectTransaction']}${params}`).then(res => {
      return res
    }).catch(err => err)
  },
  fetchTransactionsSettings ({ rootGetters }, payload) {
    return axios
      .get(rootGetters['api/transactionsSettings'], {
        params: payload,
      })
      .then((res) => res.data)
  },
  sendAuthCode ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/transactionsSendAuthCode'], data)
      .then((res) => {
        return res.data
      })
      // .catch((err) => err)
  },
  createCollectionType ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/createCollectionType'], data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  completeCollectionType ({ rootGetters }, { id, data }) {
    return axios
      .patch(rootGetters['api/completeCollectionType'](id), data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
}

const mutations = {}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
